module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('a', {
    attrs: {
      "id": "page_i"
    }
  }), _c('a', {
    attrs: {
      "id": "Cover"
    }
  }, [_c('p', {
    staticStyle: {
      "margin-top": "0px",
      "margin-left": "0px",
      "margin-right": "0px",
      "margin-bottom": "0px",
      "text-align": "center",
      "background-color": "#00007"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "100%",
      "text-align": "center"
    },
    attrs: {
      "alt": "Inside the Box: How CrossFit ® Shredded the Rules, Stripped Down the Gym, and Rebuilt My Body, by T.J. Murphy.",
      "src": "images/cover.jpg"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21c1496e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/cover.vue
// module id = 54
// module chunks = 0